export interface TransfersSliceState {
  destinationInstantEligible: boolean | undefined;
  paymentIdentification: string | undefined;
  // "outcome_unknown": the payment network didn't confirm a send that may have gone through.
  transferState: API.InstantTransferState | "outcome_unknown" | undefined;
  fees: API.InstantFeesResponse | undefined;
  fednowPayment: API.FedNowPayment | undefined;
}

export const FedNowPaymentSuccessStates = [
  "awaiting_response",
  "posted",
  "accepted_without_post",
];
